import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import ReferralManagement from "../components/ReferralManagement";
import { getDinaLaunchUrl } from "../../../actions/ReferralAction";
import { UserPageTrack } from "../../../models/User";
import { postUserPageTrack } from "../../../actions/UserAction";

const mapStateToProps = ({
  referralManagementState,
  loggedInUserState,
}: ApplicationState) => ({
  referralManagementState: referralManagementState,
  loggedInUser: loggedInUserState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getDinaLaunchUrl: (email: string) => {
      dispatch(getDinaLaunchUrl(email));
    },
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReferralManagement);
